@let v = view();
@let h = v.hit;
@let m = h.metadata;

<app-modal-header [title]="'Image ' + (position() + 1) + ' of ' + total()" [subtitle]="h.host" />

<app-modal-body flush>
  <div class="lb">
    <!-- The image, whole, on a quiet ground; ← / → step through the gallery -->
    <div class="lb__stage">
      @if (attempt() === 2) {
        <span class="lb__broken">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M3 16l5-5 4 4M14 13l2-2 5 5M4 4l16 16" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
          This image couldn't be loaded{{ m?.originalUrl ? ', from Cikisi or from the original site' : '' }}.
        </span>
      } @else {
        <img class="lb__img" [src]="src()" [alt]="v.label" (error)="imageFailed()" />
      }
      <button type="button" class="lb__nav lb__nav--prev" (click)="step(-1)" [disabled]="position() === 0" aria-label="Previous image">
        <svg width="18" height="18" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
      <button type="button" class="lb__nav lb__nav--next" (click)="step(1)" [disabled]="position() === total() - 1" aria-label="Next image" data-modal-autofocus>
        <svg width="18" height="18" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
    </div>

    <!-- Everything the response says about it -->
    <div class="lb__info">
      @if (m?.article; as a) {
        <section class="lb__section">
          <h3 class="lb__label">Appeared in</h3>
          <a class="lb__title" [href]="a.url" target="_blank" rel="noopener noreferrer"
             appFieldTip="metadata.article.title" [tipText]="tips.articleTitle" [tipDelay]="500">{{ a.title || a.url }}</a>
          <span class="lb__meta">
            <span class="rv-key" appFieldTip="metadata.article.domain_name" [tipText]="tips.domainName">{{ a.host }}</span>
            @if (a.publicationDate) {
              <span aria-hidden="true">·</span>
              <time class="rv-key" [attr.datetime]="a.publicationDate" appFieldTip="metadata.article.publication_date" [tipText]="tips.publicationDate">{{ a.publicationDate | date:'mediumDate' }}</time>
            }
          </span>
        </section>
      }

      @if (m?.description || m?.title) {
        <section class="lb__section">
          <h3 class="lb__label rv-key" appFieldTip="metadata.description" [tipText]="tips.caption">Caption</h3>
          <p class="lb__text">{{ m!.description || m!.title }}</p>
          @if (v.credit) { <span class="lb__meta">{{ v.credit }}</span> }
          @if (m!.copyright) { <span class="lb__fine">{{ m!.copyright }}</span> }
        </section>
      }

      @if (v.detected.length || m?.ocr || v.colors.length) {
        <section class="lb__section">
          <h3 class="lb__label">In the image</h3>
          @if (v.detected.length) {
            <span class="lb__tags rv-key" appFieldTip="metadata.detected" [tipText]="tips.detected">
              @for (d of v.detected; track d) { <span class="lb__tag">{{ d }}</span> }
            </span>
          }
          @if (m?.ocr) {
            <p class="lb__ocr rv-key" appFieldTip="metadata.ocr" [tipText]="tips.ocr" [tipDelay]="900">“{{ m!.ocr }}”</p>
          }
          @if (v.colors.length) {
            <div class="lb__colors rv-key" appFieldTip="metadata.colors" [tipText]="tips.colors">
              <span class="lb__bar" role="img" [attr.aria-label]="'Colours: ' + v.colorLabel">
                @for (c of v.colors; track c.name) {
                  <span [style.flex-grow]="c.ratio" [style.background]="c.swatch"></span>
                }
              </span>
              <span class="lb__swatches">
                @for (c of v.colors; track c.name) {
                  <span class="lb__swatch"><i [style.background]="c.swatch"></i>{{ c.name }} {{ c.ratio }}%</span>
                }
              </span>
            </div>
          }
        </section>
      }

      <section class="lb__section">
        <h3 class="lb__label">File</h3>
        <dl class="lb__facts">
          @if (m?.width && m?.height) {
            <div><dt>Size</dt><dd class="rv-key" appFieldTip="metadata.dimensions" [tipText]="tips.dimensions">{{ m!.width }} × {{ m!.height }}</dd></div>
          }
          @if (h.indexationDate) {
            <div><dt>Indexed</dt><dd class="rv-key" appFieldTip="indexation_date" [tipText]="tips.indexationDate">{{ h.indexationDate | date:'mediumDate' }}</dd></div>
          }
        </dl>
        <span class="lb__links">
          <a [href]="h.url" target="_blank" rel="noopener noreferrer" appFieldTip="url" [tipText]="tips.url">Open image ↗</a>
          @if (m?.originalUrl) {
            <a [href]="m!.originalUrl" target="_blank" rel="noopener noreferrer" appFieldTip="metadata.original_url" [tipText]="tips.originalUrl">Original ↗</a>
          }
        </span>
      </section>

      @if (!m) {
        <p class="lb__hint">Turn on Metadata in Response configuration to see where this image appeared and what's in it.</p>
      }
    </div>
  </div>
</app-modal-body>
